<template>
  <v-autocomplete
    :label="$t('QlikApp.Form.filters')"
    :hint="$t('QlikApp.Form.filtersHint')"
    :value="value"
    :items="dimensions"
    chips
    deletable-chips
    multiple
    small-chips
    persistent-hint
    outlined
    @input="(value) => $emit('input', value)"
  ></v-autocomplete>
</template>

<script>
import { getAppDimensions } from '@portal/qlik'

export default {
  name: 'QlikDimensionsSelector',
  props: {
    value: { type: Array, required: true },
    qAppId: { type: String, required: true },
  },
  data: () => ({
    dimensions: []
  }),
  watch: {
    app: {
      immediate: true,
      handler: function () {
        this.setupAvailableDimensions()
      }
    }
  },
  methods: {
    async setupAvailableDimensions () {
      const qDimensions = await getAppDimensions(this.qAppId)
      this.dimensions = qDimensions
                          .map(qDim => ({value: qDim.qInfo.qId, text: qDim.qMeta.title}))
                          .sort((a, b) => a.text.toLowerCase() > b.text.toLowerCase() ? 1 : -1)
    }
  },
}
</script>